<template>
    <div class="layout-main-content">
        <page-title>
            <span>应用管理</span>
        </page-title>
        <div class="content">
            <div class="left-content">
                <!-- <Icon type="md-add-circle" @click="appModal = true" />
                <div>
                    <div v-for="item in appList" :key="item.id">
                        <span @click="selectApp(item)">{{ item.name }}</span>
                        <span @click="edit(item.id)">编辑</span>
                        <span @click="deleteApp(item.id)">删除</span>
                    </div>
                </div> -->

                <Card class="tree-card">
                    <div slot="title">
                        <enc-tree-search
                            :title="'应用列表'"
                            @handelAdd="addApplication"
                            @handelSearch="searchApplication"
                        ></enc-tree-search>
                    </div>
                    <div class="tree-block-organ scrollbar">
                        <enc-tree
                            ref="encTree"
                            value-key="id"
                            :filter-method="appFilter"
                            :data-array="appList"
                            :render="renderAppContent"
                            @on-select-change="handleAppSelect"
                        ></enc-tree>
                    </div>
                </Card>
            </div>
            <div class="right-content">
                <Card class="tree-card">
                    <div class="top-content">
                        <page-title class="search-group flex">
                            <span>{{ selectedApp.name }}</span>
                        </page-title>
                        <!-- <div class="title-msg">应用编码： {{ selectedApp.code }}</div>
                        <div>应用URL： {{ selectedApp.url }}</div> -->
                        <div class="title-msg">应用描述： {{ selectedApp.remark }}</div>
                    </div>
                    <Divider />
                    <div class="bottom-content">
                        <div class="menu-content">
                            <span class="option-item" @click="newMenu"><Icon type="ios-add-circle-outline" />新建</span>
                            <span class="option-item" @click="batchDelete"><Icon type="ios-trash-outline" />批量删除</span>
                            <!-- <Tree
                                :data="menuList"
                                :render="renderContent"
                                :show-checkbox="isEdit"
                            ></Tree> -->
                            <enc-tree
                                class="tree-content scrollbar"
                                ref="menuTree"
                                v-show="menuList&&menuList.length>0"
                                :data-array="menuList"
                                :show-checkbox="true"
                                :render="renderMenuContent"
                                :draggable="true"
                                @on-check-change="handleMenuChecked"
                                @on-dragend="handleMenuDragEnd"
                                @on-toggle-expand="handelExpand"
                            ></enc-tree>
                            <no-data v-show="menuList&&menuList.length==0"></no-data>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
        <Modal
            class="application-group"
            v-model="appModal"
            :loading="true"
            @on-cancel="appCancel"
            :title="appName"
        >
            <Form
                ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                :label-width="80"
            >
                <FormItem label="应用名称" prop="name">
                    <Input ref="appName" v-model="formValidate.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="应用类型" prop="type">
                    <RadioGroup v-model="formValidate.type">
                        <Radio label="INT" :disabled="Boolean(formValidate.id)">内部</Radio>
                        <Radio label="OUT" :disabled="Boolean(formValidate.id)">外部</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="应用编码" prop="code">
                    <Input v-model="formValidate.code" placeholder="请输入" :disabled="Boolean(formValidate.id)"/>
                    <Tooltip content="应用编码由字母、数字、-组成">
                        <Icon size="16" class="theme-color cursor-point" type="md-information-circle"></Icon>
                    </Tooltip>
                </FormItem>
                <FormItem label="应用URL" prop="url">
                    <Input v-model="formValidate.url" placeholder="请输入" />
                </FormItem>
                <FormItem label="备注" prop="remark">
                    <Input v-model="formValidate.remark" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="appCancel" style="margin-left: 8px">取消</Button>
                <Button type="primary" @click="handleSubmit('formValidate')">确定</Button>
            </div>
        </Modal>
        <Modal v-model="menuModal" @on-cancel="menuCancel" :title="!menuFormValidate.id?'新增':'编辑' + editType" class="application-group">
            <Form
                ref="menuFormValidate"
                :model="menuFormValidate"
                :rules="menuFormRule"
                :label-width="80"
            >
                <FormItem label="类型" prop="type" v-if="showMenuType">
                    <RadioGroup v-model="menuFormValidate.type" @on-change="typeChange">
                        <!-- <Radio label="0" :disabled="isEdit" v-if="!showMenuType || isEdit">目录</Radio> -->
                        <Radio label="1" :disabled="isEdit">菜单</Radio>
                        <Radio label="2" :disabled="isEdit">按钮</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem :label="editType+'名称'" prop="name">
                    <Input
                        v-model="menuFormValidate.name"
                        placeholder="请输入"
                    />
                </FormItem>
                <FormItem
                    :label="editType+'URL'"
                    prop="url"
                    v-if="menuFormValidate.type === '1'"
                >
                    <Input
                        v-model="menuFormValidate.url"
                        placeholder="请输入"
                    />
                </FormItem>
                <FormItem
                    label="授权标识"
                    prop="perms"
                    v-if="menuFormValidate.type === '2'"
                >
                    <Input
                        v-model="menuFormValidate.perms"
                        placeholder="请输入"
                        :disabled="isEdit"
                    />
                    <Tooltip content="页面标识:按钮标识 如sys:add">
                        <Icon size="16" class="theme-color cursor-point" type="md-information-circle"></Icon>
                    </Tooltip>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="menuCancel" style="margin-left: 8px">取消</Button>
                <Button type="primary" @click="handleSubmit('menuFormValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import * as _ from 'lodash'
import api from '../../common/api'
import EncTreeSearch from '../../components/EncTreeSearch.vue'
import EncTree from '../../components/EncTree.vue'
import NoData from '../../components/NoData.vue'
import utils from '../../common/utils';

export default {
    data() {
        return {
            appModal: false,
            loading: false,
            appFilterStr: '',
            formValidate: {
                name: '',
                type: 'INT',
                code: '',
                url: '',
                remark: '',
            },
            editType: '',
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: '请输入应用名称',
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: '请输入应用编码',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^([a-zA-Z0-9\\-]){1,64}$/,
                        message: '应用编码由字母、数字、-组成',
                        trigger: 'blur',
                    },
                ],
                type: [
                    {
                        required: true,
                        message: '请选择类型',
                        trigger: 'change',
                    },
                ],
                url: [
                    {
                        required: true,
                        message: '请输入应用url',
                        trigger: 'blur',
                    }
                ],
                remark: [
                    {
                        required: false,
                        message: 'Mailbox cannot be empty',
                        trigger: 'blur',
                    },
                ],
            },
            appList: [],
            selectedApp: {},
            menuList: [],
            menuModal: false,
            appName: '',
            menuFormValidate: {
                type: '0',
                name: '',
                url: '',
                perms: '',
            },
            menuFormRule: {
                name: [
                    {
                        required: true,
                        message: '请输入菜单名称',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[\u4e00-\u9fa5]{1,10}$/,
                        message: '菜单名称必须1-10位汉字',
                        trigger: 'blur',
                    },
                ],
                // url: [
                //     {
                //         required: true,
                //         message: '请输入菜单URL',
                //         trigger: 'blur',
                //     }
                // ],
                perms: [
                    {
                        required: true,
                        message: '请输入授权标识',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[a-zA-Z]+:[a-zA-Z]+/,
                        message: '请输入正确的授权标识',
                        trigger: 'change',
                    },
                ],
            },
            showMenuType: true,
            selectedMenus: [],
            isEdit: false,
            dropDownVisible: false,
            prevTreeNode: {},
            expandNode: []
        }
    },
    watch: {},
    created() {
        this.getAppList()
    },
    components: {
        EncTreeSearch,
        EncTree,
        NoData
    },
    methods: {
        appFilter(node) {
            return node.name.indexOf(this.appFilterStr) > -1
        },
        addApplication() {
            this.$data.formValidate = this.$options.data().formValidate
            this.appModal = true
            this.appName = '新增应用'
            setTimeout(() => {
                this.$refs.appName.focus({
                    cursor: 'end'
                });
            });
        },
        searchApplication(val) {
            this.appFilterStr = val
            this.$refs.encTree.filter(this.appFilterStr);
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (name === 'formValidate') {
                        if (this.formValidate.id) {
                            this.appUpdate()
                        } else {
                            this.appAdd()
                        }
                    }
                    if (name === 'menuFormValidate') {
                        this.menuCheck();
                    }
                }
            })
        },
        handleMenuDragEnd(e, opt) {
            const { data, target, direction } = opt;
            if (data.type === '2') {
                this.$Message.error('按钮不支持拖拽');
                return;
            }
            if (direction === 'inner' || target.parentId !== data.parentId) {
                this.$Message.warning('只能同级内拖拽');
            } else {
                api.menuDragSort({
                    id: data.id,
                    oldOrderNum: data.orderNum,
                    orderNum: target.orderNum,
                    parentId: data.parentId,
                    applicationId: this.selectedApp.id
                }).then((res) => {
                    if (res.resultCode === 0) {
                        opt.success();
                        this.$Message.success('排序成功');
                    } else {
                        this.$Message.warning(res.resultMessage || '排序失败');
                    }
                }).catch((err) => {
                    this.$Message.error(err.resultMessage || '排序异常');
                })
            }
        },
        handleReset(name) {
            this.$refs[name].resetFields()
        },
        appCancel() {
            this.appModal = false
            this.handleReset('formValidate')
        },
        appUpdate() {
            api.appUpdate(this.formValidate).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('编辑成功')
                    this.handleReset('formValidate')
                    this.getAppList()
                    this.appModal = false
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        appAdd() {
            api.appAdd(this.formValidate).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('新建成功')
                    this.handleReset('formValidate')
                    this.appModal = false
                    this.getAppList()
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        getAppList() {
            const param = {
                condition: '',
                pageNum: 1,
                pageSize: 0,
            }
            api.getAppList(param).then((res) => {
                if (res.resultCode === 0 && res.data && res.data.data && res.data.data.length) {
                    const list = res.data.data;
                    list.forEach((item) => {
                        item.dropDownVisible = false;
                        item.selected = false;
                    })
                    const ap = list[0];
                    ap.selected = true;
                    this.appList = list;
                    this.selectedApp = ap;
                    this.getMenuList()
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        getAppInfo(param) {
            api.getAppInfo(param).then((res) => {
                if (res.resultCode === 0) {
                    this.formValidate = res.data
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        editApp(id) {
            this.appModal = true
            this.appName = '编辑应用'
            this.getAppInfo({ appId: id })
        },
        addApp() {
            this.appModal = true
        },
        deleteApp(id) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>确认删除该应用吗？</p>',
                onOk: () => {
                    api.appDelete([id]).then((res) => {
                        if (res.resultCode === 0) {
                            this.$Message.success('删除成功')
                            this.getAppList()
                        } else {
                            this.$Message.error(res.resultMessage)
                        }
                    })
                },
                onCancel: () => {},
            })
        },
        selectApp(data) {
            this.selectedApp = data
            this.getMenuList()
        },
        getMenuList() {
            if (!this.selectedApp || !this.selectedApp.id) {
                return
            }
            const param = {
                appId: this.selectedApp.id,
                authorityCategory: 'SYSTEM_MENU',
                condition: '',
                pageNum: 1,
                pageSize: 0,
            }
            api.getMenuList(param).then((res) => {
                if (res.resultCode === 0) {
                    this.menuList = res.data;
                    utils.treeForeach(this.menuList, 'node', (item) => {
                        // item.children = item.node;
                        this.$set(item, 'children', item.node)
                        // delete item.node;
                        // console.log(item)
                    })
                    this.menuList = utils.treeSort(this.menuList, 'children', 'orderNum');
                    this.menuList = this.convertList(_.cloneDeep(this.menuList));
                    // console.log('this.menuList', this.menuList)
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        renderAppContent(h, { data }) {
            const self = this;
            return h('span', {}, [
                h('span', {
                    domProps: {
                        title: data.name
                    },
                    class: 'tree-node-text'
                }, data.name),
                h('Dropdown', {
                    style: {
                        fontSize: '20px',
                        position: 'absolute',
                        right: '0px'
                    },
                    props: {
                        trigger: 'custom',
                        visible: data.dropDownVisible,
                        placement: 'bottom-end',
                        'stop-propagation': true
                    },
                    on: {
                        'on-clickoutside': () => { data.dropDownVisible = false; }
                    }
                }, [
                    h('Icon', {
                        props: {
                            type: 'md-more'
                        },
                        style: {
                            fontSize: '20px',
                            position: 'absolute',
                            right: '0px',
                            top: '8px'
                        },
                        on: {
                            click: (e) => {
                                e.stopPropagation();
                                if (self.prevTreeNode) {
                                    self.prevTreeNode.dropDownVisible = false;
                                }
                                data.dropDownVisible = true;
                                self.prevTreeNode = data;
                            }
                        }
                    }),
                    h('DropdownMenu', {
                        slot: 'list'
                    }, [
                        h('DropdownItem', {
                            props: {
                                name: 'edit'
                            },
                            nativeOn: {
                                click: ($event) => {
                                    $event.stopPropagation();
                                    this.appTreeDropDownClick('edit', data)
                                }
                            }
                        }, '编辑'),
                        h('DropdownItem', {
                            props: {
                                name: 'delete'
                            },
                            nativeOn: {
                                click: ($event) => {
                                    $event.stopPropagation();
                                    this.appTreeDropDownClick('delete', data)
                                }
                            }
                        }, '删除'),
                    ])
                ])
            ])
        },
        // eslint-disable-next-line default-case
        appTreeDropDownClick(name, data) {
            // eslint-disable-next-line default-case
            switch (name) {
            case 'edit':
                this.editApp(data.id)
                break;
            case 'delete':
                this.deleteApp(data.id)
                break;
            }
        },
        renderMenuContent(h, { data }) {
            return h('span', {}, [
                h('span', data.name),
                [
                    h('Icon', {
                        props: {
                            type: 'md-add-circle'
                        },
                        class: 'theme-color',
                        style: {
                            fontSize: '20px',
                            position: 'absolute',
                            right: '60px',
                            top: '8px'
                        },
                        on: {
                            click: () => { this.addMenu(data) }
                        }
                    }),
                    h('Icon', {
                        props: {
                            type: 'ios-create'
                        },
                        class: 'theme-color',
                        style: {
                            fontSize: '20px',
                            position: 'absolute',
                            right: '35px',
                            top: '8px'
                        },
                        on: {
                            click: () => { this.editMenu(data) }
                        }
                    }),
                    h('Icon', {
                        props: {
                            type: 'md-trash'
                        },
                        class: 'theme-color',
                        style: {
                            fontSize: '20px',
                            position: 'absolute',
                            right: '10px',
                            top: '8px'
                        },
                        on: {
                            click: () => { this.deleteMenu(data) }
                        }
                    }),
                ]
            ])
        },
        newMenu() {
            this.menuModal = true
            this.isEdit = false
            this.showMenuType = true
            this.menuFormValidate = {
                type: '1',
                name: '',
                url: '',
                perms: '',
                orderNum: this.menuList && this.menuList.length > 0 ? this.menuList[this.menuList.length - 1].orderNum + 1 : 1,
            }
            this.setRuleName()
        },
        addMenu(data) {
            this.menuModal = true
            this.isEdit = false
            this.showMenuType = true
            this.menuFormValidate = {
                type: '1',
                name: '',
                url: '',
                perms: '',
                parentId: data.id ? data.id : 0,
                orderNum: data.children && data.children.length > 0 ? data.children[data.children.length - 1].orderNum + 1 : 1,
            }
            this.editType = '菜单'
            this.setRuleName()
        },
        editMenu(data) {
            this.menuModal = true
            this.showMenuType = true
            this.isEdit = true
            this.menuFormValidate = _.cloneDeep(data)
            if (this.menuFormValidate.type === '1') {
                this.editType = '菜单'
            } else if (this.menuFormValidate.type === '2') {
                this.editType = '按钮'
            }
            //  else {
            //     this.editType = '目录'
            // }
            this.setRuleName()
        },
        setRuleName() {
            this.menuFormRule.name = {
                required: true,
                message: `请输入${this.editType}名称`,
                trigger: 'blur',
            }
        },
        menuAdd() {
            const param = Object.assign(this.menuFormValidate, { applicationId: this.selectedApp.id })
            api.menuAdd(param).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('新增成功')
                    this.handleReset('menuFormValidate')
                    this.menuModal = false
                    this.getMenuList();
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        menuUpdate() {
            const param = Object.assign(this.menuFormValidate, { applicationId: this.selectedApp.id })
            api.menuUpdate(param).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('编辑成功')
                    this.handleReset('menuFormValidate')
                    this.menuModal = false
                    this.getMenuList();
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        menuDelete(ids) {
            api.menuDelete(ids).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('删除成功')
                    this.selectedMenus = []
                    this.getMenuList();
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        deleteMenu(data) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>确认删除该菜单吗？</p>',
                onOk: () => {
                    this.menuDelete([data.id]);
                },
                onCancel: () => {},
            })
        },
        batchDelete() {
            const ids = this.selectedMenus.map((res) => {
                console.log()
                return res.id;
            })
            if (ids.length === 0) {
                this.$Message.error('请选择需要删除的行')
                return;
            }
            this.$Modal.confirm({
                title: '提示',
                content: '<p>确认批量删除菜单吗？</p>',
                onOk: () => {
                    this.menuDelete(ids);
                },
                onCancel: () => {},
            })
        },
        menuCancel() {
            this.menuModal = false
            this.handleReset('menuFormValidate')
        },
        handleMenuChecked(selections) {
            this.selectedMenus = selections;
        },
        handleAppSelect(selections, node) {
            if (selections.length < 1) {
                this.$refs.encTree.setSelectedNodes([node.id])
                return
            }
            this.selectApp(node)
            this.expandNode = [];
        },
        typeChange(val) {
            console.log(val)
            this.menuFormValidate.url = '';
            this.menuFormValidate.perms = '';
            this.handleReset('menuFormValidate')
            setTimeout(() => {
                this.menuFormValidate.type = val;
                // if (this.menuFormValidate.type === '0') {
                //     this.menuFormRule.url = [];
                //     this.menuFormRule.perms = [];
                //     this.editType = '目录'
                // } else
                if (this.menuFormValidate.type === '1') {
                    // this.menuFormRule.url = [{
                    //     required: true,
                    //     message: '请输入菜单URL',
                    //     trigger: 'blur',
                    // }];
                    this.menuFormRule.perms = [];
                    this.editType = '菜单'
                } else {
                    this.menuFormRule.url = [];
                    this.editType = '按钮'
                    this.menuFormRule.perms = [{
                        required: true,
                        message: '请输入授权标识',
                        trigger: 'blur',
                    }, {
                        pattern: /^[a-zA-Z]+:[a-zA-Z]+/,
                        message: '请输入正确的授权标识',
                        trigger: 'change',
                    }];
                }
                this.menuFormRule.name = {
                    required: true,
                    message: `请输入${this.editType}名称`,
                    trigger: 'blur',
                }
            })
        },
        menuCheck() {
            if (this.menuFormValidate.type === 2) {
                return;
            }
            const params = {
                name: this.menuFormValidate.name,
                type: this.menuFormValidate.type,
                parentId: this.menuFormValidate.parentId ? this.menuFormValidate.parentId : 0,
                applicationId: this.selectedApp.id
            }
            api.menuCheck(params).then((res) => {
                if (res.resultCode === 0) {
                    if (this.menuFormValidate.id) {
                        this.menuUpdate()
                    } else {
                        // eslint-disable-next-line no-unused-expressions
                        res.data ? this.$Message.error('当前菜单/按钮已存在，请编辑!') : this.menuAdd()
                    }
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        handelExpand(item) {
            if (item.expand) {
                this.expandNode.push(item);
            } else {
                const index = this.expandNode.findIndex((obj) => obj.id === item.id)
                this.expandNode.splice(index, 1);
            }
        },
        convertList(data) {
            // 递归
            const self = this;
            function recursive(list) {
                const obj = list.map((res) => {
                    let data1 = {}
                    const expand = self.expandNode.findIndex((obj1) => obj1.id === res.id) >= 0;
                    if (res.node && res.node.length > 0) {
                        data1 = Object.assign(res, { expand, node: recursive(res.node) });
                    } else {
                        data1 = Object.assign(res, { expand });
                    }
                    return data1;
                });
                return obj;
            }
            return recursive(data);
        },
    },
}
</script>

<style lang="less" scoped>
    .tree-block-organ{
        max-height: calc(100vh - 220px);
        overflow-x: hidden;
    }
    .title-msg{
        margin-top: 18px;
    }
    /deep/ .tree-node-text{
        text-overflow: ellipsis;
        position: relative;
        width: 90%;
        overflow: hidden;
        display: inline-block;
    }
.layout-main-content{
    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }
    .head-title {
        font-size: 24px;
        font-weight: 600;
        color: var(--base-font-color);
        line-height: 33px;
    }
    .title .icon {
        width: 8px;
        height: 24px;
        background: var(--theme-menu-item-selected-bg-color);
        margin-right: 12px;
        display: inline-block;
    }
    .option-item{
        color: var(--theme-menu-item-selected-bg-color);
        margin-right: 20px;
        cursor: pointer;
        i{
            color: var(--theme-menu-item-selected-bg-color);
            margin-right: 5px;
        }
    }
    .title .tips {
        background: var(--theme-menu-item-selected-shadow-color);
        border-radius: 14px;
        font-size: 16px;
        font-weight: 500;
        color: var(--theme-menu-item-selected-bg-color);
        line-height: 20px;
        padding: 3px 20px;
        margin-left: 30px;
    }
    .right-content,
    .left-content {
        /* background-color: #ffffff; */
        height: 100%;
        float: left;
    }
    .content {
        height: calc(100% - 40px);
        margin-top: 15px;
        padding: 0;
    }
    .left-content {
        width: 296px;
        margin-right: 12px;
    }
    .right-content {
        width: calc(100% - 296px - 12px);
        /deep/ .ivu-card-body{
            height: 100%;
            padding-left: 0;
            padding-right: 0;
        }
    }
    .top-content {
        padding: 10px 32px 0;
    }
    .bottom-content {
        /*padding: 6px 30px 40px;*/
        height: calc(100% - 175px);
        position: relative;
    }
    .menu-content {
        background: var(--comp-block-bg-color);
        height: 100%;
        width: calc(100% - 100px);
        padding: 20px;
        margin: 32px;
        position: relative;
    }
    .tree-content{
        position: relative;
        height: 100%;
    }
    .edit-button {
        position: absolute;
        left: calc(100% - 130px);
        bottom: 40px;
        background-color: var(--theme-menu-item-selected-bg-color);
        color: #ffffff;
        height: 50px;
        width: 50px;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
        transition: all 0.2s ease-in-out;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span {
            display: none;
            margin-right: 10px;
            white-space: nowrap;
        }
    }
    .edit-button:hover {
        width: 100px;
        span {
            display: inline-block;
        }
    }
    .tree-block {
        max-height: 700px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .tree-card {
        height: 100%;
        .ivu-card-body {
            height: 100%;
        }
        .ivu-tree-title{
            /*width: calc(100% - 30px);*/
            .ivu-icon{
                display: none;
            }
            &:hover{
                .ivu-icon{
                    display: inline-block;
                }
            }
        }
    }
}

.application-group {
    /deep/ .ivu-tooltip {
        position: absolute;
        margin-left: 6px;
    }
    form {
        padding-right: 34px;
    }
}

</style>
